<template>
    <div>
        <K2Row>
            <div class="col-lg-6 reportAreaContentPart2ReportType">
                <label v-if="mode === 'New'" class="lblNewTermlyReport">{{lang("New Termly Report")}}</label>
                <label v-if="mode === 'Pending' || mode === 'View'" class="lblTermlyReportList">
                    {{lang("Termly Report List")}}
                </label>
            </div>
            <div class="col-lg-6 reportAreaContentPart2Button">
                <div v-if="mode === 'New'  && !tourRunning">
                    <el-button v-on:click="SaveTermlyReport()" class="font btnSubmit">
                        {{lang("Save Draft")}}
                    </el-button>
                </div>
                <div v-if="mode === 'New' && tourRunning">
                    <el-button class="font btnSubmit" id="btnNewDraft">
                        {{lang("Save Draft")}}
                    </el-button>
                </div>
                <div v-if="mode === 'Pending' || mode === 'View' || mode === 'Draft'">
                    <el-button v-on:click="$emit('action','BackToList', '')" class="font btnBackToList">
                        {{lang("Back To List")}}
                    </el-button>
                </div>
            </div>
        </K2Row>

        <div v-if="mode === 'Pending' || mode === 'View' || mode === 'Draft'"
             class="col-lg-12 row reportAreaContentPart2NameClass">
            <div class="col-lg-6">
              <el-button v-if="mode === 'Draft' && $emit('checkNew')" size="small"
                         v-on:click="$emit('updateTermlyReport','Delete')"
                         class="font btnSave">
                {{lang("Delete")}}
              </el-button>
            </div>
            <div class="col-lg-6" style="text-align: right;" v-if="nextSave">
              <el-button size="small"
                         v-on:click="()=>handleGeneratePDF(true)"
                         class="font btnSave">
                {{lang("Preview")}}
              </el-button>
                <el-button @click="handleSave('save')" class="font btnSave" size="small">
                    {{lang("Save")}}
                </el-button>
                <el-button v-on:click="handleSave('submit')" v-if="checkSubmit" class="font btnDownload" size="small">
                    {{lang("Submit")}}
                </el-button>
            </div>
            <div class="col-lg-6" style="text-align: right;"
                 v-if="(nextTurn || (userID === 'CON202100053436' && mode !== 'View') )">
                <el-button v-on:click="$emit('signTermlyReportComments','Approved')" class="font btnSave">
                    {{lang("Approve")}}
                </el-button>
                <el-button v-on:click="$emit('signTermlyReportComments','Reject')" class="font btnSave">
                    {{lang("Reject")}}
                </el-button>
            </div>
            <div class="col-lg-6" style="text-align: right;" v-if="mode === 'View'">
              <el-button v-on:click="handleGeneratePDF" class="actionButton btnDownload">
                {{lang("Generate")}}
              </el-button>
              <el-button v-on:click="handleSingleDownload" class="actionButton btnDownload">
                {{lang("Download")}}
              </el-button>
                <!--<el-button v-on:click="$emit('publishTermlyReport')" v-if="this.allowPublish"-->
                <!--class="actionButton btnDownload">-->
                <!--{{lang("Publish")}}-->
                <!--</el-button>-->
            </div>
        </div>
        <div v-if="1===2">
            <!--<div v-if="mode === 'New'" class="col-lg-12 reportAreaContentPart2SelectTeacher row" style="padding: 0px; ">-->
            <!--<div class="col-lg-12">-->
            <!--<label class="font">Invite Teacher</label>-->
            <!--</div>-->
            <!--<div class="col-lg-4">-->
            <!--<label class="font">Teacher</label>-->
            <!--<el-select v-model="ddlClassTeacher" placeholder="Select Teacher" class="pro-edt-select slTeacher">-->
            <!--<el-option-->
            <!--v-for="item in classTeacherList"-->
            <!--:key="item.CONid"-->
            <!--:label="item.CONname"-->
            <!--:value="item.CONid">-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</div>-->
            <!--<div class="col-lg-4">-->
            <!--<label class="font">Role</label>-->
            <!--<input type="text" class="form-control" v-model="inputTeacherType">-->
            <!--</div>-->
            <!--<div class="col-lg-2">-->
            <!--<label class="font" style="text-align: center;">Main</label>-->
            <!--<el-checkbox v-model="checkedTeacher" style="text-align: center;"></el-checkbox>-->
            <!--</div>-->
            <!--<div class="col-lg-2">-->
            <!--<label>&nbsp;</label>-->
            <!--<el-button v-on:click="addTeacher()" class="actionButton btnDownload">-->
            <!--Add-->
            <!--</el-button>-->
            <!--</div>-->
            <!--<div class="col-lg-12">-->
            <!--<div v-if="selectedTeacherList.length>0" class="col-lg-12">-->
            <!--<data-tables :data="selectedTeacherList" class="listTable">-->
            <!--<el-table-column v-for="selectedTeacherListColumnInfo in selectedTeacherListColumn" :prop="selectedTeacherListColumnInfo.prop"-->
            <!--:label="selectedTeacherListColumnInfo.label" :key="selectedTeacherListColumnInfo.prop"-->
            <!--sortable="custom">-->
            <!--</el-table-column>-->
            <!--<el-table-column label="Main" width="200px">-->
            <!--<template slot-scope="scope">-->
            <!--<span v-if="scope.row.Checked">Yes</span>-->
            <!--<span v-if="!scope.row.Checked">No</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="Delete" width="200px">-->
            <!--<template slot-scope="scope">-->
            <!--<el-button v-on:click="deleteTeacher(scope.row)" class="actionButton btnDownload">-->
            <!--Delete-->
            <!--</el-button>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--</data-tables>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
        </div>
        <div class="col-lg-12 reportAreaContentPart2Header">
            <div v-if="mode === 'New'">
                <div v-if="teacherAndApproverList.length>0">
                    <div class="divVerficationTeacherTitle" id="divVerficationTeacherTitle">
                        <span class="spanVerification"><i class="material-icons">assignment_late</i> Verification</span>
                        <span class="spanVerificationMsg">
                            Please verify the information below. Please do not save draft and inform your PLO if the information is incorrect.
                            <!-- Please verify Teacher & Coordinator & Principal, Please do not save Draft and inform PL -->
                        </span>
                    </div>
                    <div class="divVerficationTeacherMsg">
                        Select the names of teachers to be included in Summative Report:
                        <!-- Remove not related language teacher by clicking the check box -->
                    </div>
                    <div v-for="(item, index) in teacherAndApproverList">
                        <div class="divVerficationTeacherDetails"
                             :class="[(index+1)%2===0 ? 'divVerficationTeacherDetailsRight' : '', item.RoleTypeActive === 'No' ? 'divVerficationTeacherDetailsDisable' : '']">
                            <span class="spanVerficationTeacherDetailsIcon">
                                <i v-if="item.RoleTypeActive === 'Yes'" class="material-icons"
                                   style="color:#426DFF;cursor:pointer;"
                                   v-on:click="$emit('adddeleteLanguageTeacher',item)">check_box</i>
                                <i v-if="item.RoleTypeActive === 'No'" class="material-icons"
                                   style="color:#A0ABC7;cursor:pointer;"
                                   v-on:click="$emit('adddeleteLanguageTeacher',item)">check_box_outline_blank</i>
                            </span>
                            <span class="spanVerficationTeacherDetailsName"><span>{{item.Name}}</span></span>
                            <span class="spanVerficationTeacherDetailsRole">{{item.Role}}</span>
                        </div>
                        <div style="clear: both;" v-if="(index+1)%2===0"></div>
                    </div>
                    <div style="clear: both;"></div>
                </div>
                <div v-if="teacherAndApproverList.length<1">
                    <div class="divVerficationTeacherTitle">
                        <i class="material-icons">assignment_late</i> Verification : Missing Teacher &
                        Coordinator & Principal, Please do not save Draft and inform PL
                    </div>
                </div>
            </div>

            <div id="divNewTitle">
              <K2Row v-if="mode === 'New' || userMain">
                <el-input type="textarea" autosize :disabled="currentEditor && currentEditor.Position.includes('Class Teacher')"
                          v-model="termlyReportHeader"></el-input>
                <K2Dropdown :dropdownList="titleSuggestList" @change="updateTermlyReportHeader"/>
              </K2Row>
              <K2Row v-if=" (showCNHeader() && userMain) || (showCNHeader() && mode === 'New')">
                <el-input type="textarea" autosize
                          v-model="termlyReportHeaderCN"></el-input>
                <K2Dropdown :dropdownList="titleSuggestList" @change="updateTermlyReportHeader"/>
              </K2Row>

            </div>
            <div v-if="mode !== 'New'">
                <div v-for="(flowInfo) in userFlow" :key="flowInfo.ConID">
                    <div v-if="flowInfo.Type === 'Creator' || (flowInfo.Type === 'Main' && !flowInfo.Position.includes('Class Teacher'))">
                        <div v-for="comment in getCommentByDomain('', 'header', flowInfo.ConID)">

                            <K2Row class="groupComment p-1">
                                <!--<label class="font eachCommentNo1"></label>-->
                                <label class="font eachCommentComment1">{{comment.TeRpCMComment}}</label>
                                <label class="font eachCommentInfo1">{{comment.CONname}}</label>
                                <!--label class="font" v-if="nextTurn"
                                       :class="comment.editComment ? 'eachCommentEditComment1_Active' : 'eachCommentEditComment1'"
                                       @click="editComment(comment) ">
                                    <span><i class="material-icons">create</i></span>
                                </label-->
                                <label class="font" v-if="allowEdit"
                                       :class="comment.editComment ? 'eachCommentEditComment1_Active' : 'eachCommentEditComment1'"
                                       @click="editComment(comment) ">
                                    <span><i class="material-icons">create</i></span>
                                </label>
                            </K2Row>
                            <K2Row v-if="comment.editComment && allowEdit" class="groupComment p-1">
                                <!--<K2Row v-if="comment.editComment && nextTurn" class="groupComment p-1">-->
                                <div class="editCommentValue">
                                    <K2Textarea rows="2" v-model="comment.editCommentValue"/>

                                    <!--<el-input type="textarea" autosize v-model="comment.editCommentValue"-->
                                    <!--class="mb-2"></el-input>-->
                                </div>
                                <div class="editCommentButton">
                                    <el-button v-on:click="$emit('updateComment',comment)" class="font btnSubmit"
                                               style="background:#426DFF;">
                                        {{lang("Save")}}
                                    </el-button>
                                </div>
                            </K2Row>
                        </div>


                      <div v-for="comment in getCommentByDomain('', 'headerCN', flowInfo.ConID)" v-if="showCNHeader()">
                        <K2Row class="groupComment p-1">
                          <label class="font eachCommentComment1"
                                 v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                          <label class="font eachCommentInfo1">{{comment.CONname}}</label>
                          <label class="font" v-if="allowEdit"
                                 :class="comment.editComment ? 'eachCommentEditComment1_Active' : 'eachCommentEditComment1'"
                                 @click="editComment(comment) ">
                            <span><i class="material-icons">create</i></span>
                          </label>
                        </K2Row>
                        <K2Row v-if="comment.editComment && allowEdit" class="groupComment p-1">
                          <div class="editCommentValue">
                            <K2Textarea rows="2" v-model="comment.editCommentValue"/>
                          </div>
                          <div class="editCommentButton">
                            <el-button v-on:click="$emit('updateComment',comment)" class="font btnSubmit"
                                       style="background:#426DFF;">
                              {{lang("Save")}}
                            </el-button>
                          </div>
                        </K2Row>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12 reportAreaContentPart2StudentInfo">
            <div>
                <label>{{lang("Student Information")}}</label>
            </div>
            <hr>

            <div class="row divStudentInfo">
                <div class="col-lg-6">
                    <label class="font">{{lang("Name of child")}}: {{studentInfoPart.name}}</label>
                </div>
                <div class="col-lg-6">
                    <label class="font">{{lang("Class")}}: {{studentInfoPart.class}}</label>

                </div>
                <div class="col-lg-6">
                    <label class="font">
                        {{lang("Date of Birth")}}:
                        {{moment(studentInfoPart.dob, "DD/MM/YYYY HH:mm:ss").format("Do MMMM YYYY")}}
                    </label>
                </div>
                <div class="col-lg-6">
                    <label class="font">{{lang("Current Age")}}: {{studentInfoPart.age}}</label>
                </div>
                <div class="col-lg-6">
                    <label class="font">
                        {{lang("Period of Report")}}: {{getReportPeriod(studentInfoPart.semdFrom,
                        studentInfoPart.semdTo)}}
                        <!--From 3rd January to 26th May 2023-->
                    </label>
                </div>
                <div class="col-lg-6">
                    <label class="font">
                        {{lang("Student Join Date")}}:
                        {{moment(studentInfoPart.joinDate, "DD/MM/YYYY HH:mm:ss").format("Do MMMM YYYY")}}
                    </label>
                </div>
            </div>
            <!--<div v-if="mode === 'New' || userMain" class="groupInput">-->
            <!--<label class="font">{{lang("Remark")}}</label>-->
            <!--<el-input type="textarea" autosize v-model="termlyReportContent"></el-input>-->
            <!--</div>-->
            <!--<div v-else>-->
            <!--<label class="font">{{lang("Remark")}}</label>-->
            <!--</div>-->

            <!--TERMLY REPORT COMMENT disable on request 012023-->
            <!--div v-if="mode !== 'New'">
                <div v-for="(flowInfo, index) in userFlow">

                    <div v-if="flowInfo.Type === 'Creator' || flowInfo.Type === 'Main'">
                        <div v-for="comment in getCommentByDomain('', 'content', flowInfo.ConID)">
                            <K2Row class="groupComment p-1">
                                <label class="font eachCommentComment1"
                                       v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                                <label class="font eachCommentInfo1">{{comment.CONname}}</label>
                                <label class="font"
                                       :class="comment.editComment ? 'eachCommentEditComment1_Active' : 'eachCommentEditComment1'"
                                       v-if="allowEdit" @click="editComment(comment)">
                                    <span><i class="material-icons">create</i></span>
                                </label>
                            </K2Row>
                            <K2Row v-if="allowEdit && comment.editComment" class="groupComment p-1">
                                <div class="editCommentValue">
                                    <K2Textarea rows="4" v-model="comment.editCommentValue"/>
                                </div>

                                <div class="editCommentButton">
                                    <el-button v-on:click="$emit('updateComment',comment)" class="font btnSubmit"
                                               style="background:#426DFF;">
                                        {{lang("Save")}}
                                    </el-button>
                                </div>
                            </K2Row>
                        </div>
                    </div>
                </div>
            </div-->
        </div>
        <div class="col-lg-12 reportAreaContentPart2Summary">
            <!--<div class="reportAreaContentPart2SummaryTitle">-->
            <!--<label class="lblReportAreaContentPart2Summary">-->
            <!--{{lang("Summary of In School Learning")}}-->
            <!--</label>-->
            <!--</div>-->
            <!--<hr>-->
            <div class="divEachDomain" v-for="domain in groupDomain">
                <div v-if="mode === 'New' || userMain" class="mb-2">
                    <K2Row class="mb-2" align="center" space-between="true">
                        <label class="font mb-0">{{domain.Domain}}
                            <!--<span v-for="(item, key, index) in groupDomainMapChinese"-->
                            <!--v-if="domain.Domain === item">{{key}}</span>-->
                        </label>
                        <!--<K2Switch v-if="domain.Domain === 'The Child as Communicator'" :state="domain.Domain.checked" :item="domain.Domain" withoutLabel="true" @onchange="onCheck"-->
                        <!--activeText="Mandarin" inactiveText="English"></K2Switch>-->
                    </K2Row>
                    <div class="groupInput">
                        <label class="font">{{lang("Comment")}}</label>
                        <!--<el-input type="textarea" autosize v-model="domain.Comment"></el-input>-->
                        <K2Textarea rows="2" v-model="domain.Comment"/>
                    </div>
                </div>
                <div v-if="checkIsOptionalDomain(domain.Domain,'data')">
                    <K2Row class="mb-2" align="center" space-between="true"
                           v-if="userFlow.length && mode !== 'New' && !userMain">
                        <label class="font mb-0">{{domain.Domain}}
                            <span v-for="(item, key, index) in groupDomainMapChinese"
                                  v-if="domain.Domain === item">{{key}}</span>
                        </label>
                    </K2Row>
                    <div v-for="(flowInfo, index) in userFlow">
                        <div v-if="flowInfo.Type === 'Creator' || flowInfo.Type === 'Main'">
                            <div v-for="comment in getCommentByDomain(domain.Domain, 'data', flowInfo.ConID)">
                                <K2Row class="groupComment p-1">

                                    <!--<label class="font eachCommentNo1"></label>-->
                                    <label class="font eachCommentComment1">{{comment.TeRpCMComment}}</label>
                                    <label class="font eachCommentInfo1">{{comment.CONname}}</label>
                                    <label class="font"
                                           :class="comment.editComment ? 'eachCommentEditComment1_Active' : 'eachCommentEditComment1'"
                                           v-if="allowEdit" @click="editComment(comment)">
                                        <span><i class="material-icons">create</i></span>
                                    </label>
                                </K2Row>
                                <K2Row v-if="allowEdit && comment.editComment" class="groupComment p-1">
                                    <div class="editCommentValue">
                                        <!--<el-input type="textarea" autosize-->
                                        <!--v-model="comment.editCommentValue"-->
                                        <!--class="mb-2"></el-input>-->
                                        <K2Textarea rows="4" v-model="comment.editCommentValue"/>
                                    </div>
                                    <div class="editCommentButton">
                                        <el-button v-on:click="$emit('updateComment',comment)"
                                                   class="font btnSubmit" style="background:#426DFF;">
                                            {{lang("Save")}}
                                        </el-button>
                                    </div>
                                </K2Row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12 reportAreaContentPart2Summary"
             v-if="checkIsOptionalDomain('','single') || mode ==='draft'">
            <div class="reportAreaContentPart2SummaryTitle">
                <label class="lblReportAreaContentPart2Summary">
                    {{lang("Comments from Specialist Teacher(s) 专业老师的评语")}}
                </label>
            </div>
            <hr>
            <div class="divEachDomain" v-for="flowInfo in userFlow">
                <div v-if="flowInfo.Type === 'NonMain'">
                    <div v-if="mode === 'Draft' && !userMain && flowInfo.ConID === userID">
                        <div>
                            <label class="font">{{flowInfo.ConName}} ( {{flowInfo.Position}} )</label>
                        </div>
                        <div class="groupInput">
                            <label class="font">{{lang("Comment")}}</label>
                            <el-input type="textarea" autosize v-model="singleComment"></el-input>
                        </div>
                    </div>
                    <div>
                        <div v-for="(comment, index) in getCommentByDomain('', 'single', flowInfo.ConID)">
                            <K2Row align="center">
                                <label class="font me-2">{{flowInfo.ConName}} ( {{flowInfo.Position}} )</label>
                                <K2Confirm v-if="mode ==='Draft' && (allowEdit || checkSubmit) "
                                           :title="lang('Are you sure you want to remove?')"
                                           noChildren="true" class="termly_remove_icon"
                                           theme="1" @confirm="removeTeacher(flowInfo)" icon="remove_circle_outline"
                                           :color="uiVariable.color.error2"/>
                            </K2Row>
                            <K2Row class="groupComment p-1">
                                <!--<label class="font eachCommentNo2"></label>-->
                                <label class="font eachCommentComment2"
                                       v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                                <label class="font"
                                       :class="comment.editComment ? 'eachCommentEditComment1_Active' : 'eachCommentEditComment1'"
                                       v-if="allowEdit" @click="editComment(comment)">
                                    <span><i class="material-icons">create</i></span>
                                </label>
                            </K2Row>
                            <K2Row v-if="allowEdit && comment.editComment" class="groupComment p-1">
                                <div class="editCommentValue">
                                    <!--<el-input type="textarea" autosize v-model="comment.editCommentValue"-->
                                    <!--class="mb-2"></el-input>-->
                                    <K2Textarea rows="4" v-model="comment.editCommentValue"/>
                                </div>
                                <div class="editCommentButton">
                                    <el-button v-on:click="$emit('updateComment',comment)" class="font btnSubmit"
                                               style="background:#426DFF;">
                                        {{lang("Save")}}
                                    </el-button>
                                </div>
                            </K2Row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { lang } from "../../../locale";
  import K2Row from "../../../uiComponents/k2Row/k2Row";
  import DataSource from "../../../data/datasource";
  import K2Textarea from "../../../uiComponents/k2Input/k2Textarea";
  import K2Dropdown from "../../../uiComponents/k2Dropdown/k2Dropdown";
  import { cloneObject, getFormatDate, singleDownload } from "@/helper/utily";
  import { getUserID } from "@/helper/util_custom";

  import K2Button from "../../../uiComponents/k2Button/k2Button";
  import K2Text from "../../../uiComponents/k2Text/k2Text";
  import uiVariable from "../../../config/uiVariable";
  import K2Icon from "../../../uiComponents/k2Icon/k2MAIcon";
  import K2Confirm from "../../../uiComponents/k2Confirm/k2Confirm";
  import K2Switch from "../../../uiComponents/k2Switch/k2Switch";
  import moment from "moment";

  export default {
    name: "TermlyContent",
    components: { K2Switch, K2Confirm, K2Icon, K2Text, K2Button, K2Dropdown, K2Textarea, K2Row },
    props: ["mode", "ddlClass", "ddlClassList", "tourRunning", "action", "currentClassStudentName",
      "nextSave", "submitTermlyReport", "updateTermlyReport", "nextTurn", "userID", "currentEditor",
      "signTermlyReportComments", "publishTermlyReport", "allowPublish", "teacherAndApproverList",
      "adddeleteLanguageTeacher", "userMain", "passUserFlow", "updateComment", "ddlStudent", "ddlStudentInfo",
      "studentInfoPart","termlyReportPublish","dsKgm_TermlyReport",
      "groupDomainMapChinese", "passTermlyReportDomainComment", "checkSubmit", "passTermlyReportContent", "passSingleComment",
      "currentTermlyReportID", "ddlStudent", "selectedTeacherList", "clear", "passTermlyReportHeader", "passTermlyReportHeaderCN",
      "passGroupDomain", "termlyReportListInt", "dllStudentList", "allowEditUser", "getTermlyReport", "autoGenerateTitle"],
    async mounted() {
      this.resetTitle();
      this.groupDomain = this.passGroupDomain;
      this.userFlow = this.passUserFlow;
      this.getTitleSuggestList();
      this.checkAllowEditStatus();
    },
    watch: {
      allowEditUser: function(value) {
        if (value) {
          this.checkAllowEditStatus();
        }
      },
      nextTurn: function(value) {
        if (value) {
          this.checkAllowEditStatus();
        }
      },
      passTermlyReportHeader: function(value) {
        if (value) {
          this.$set(this, 'termlyReportHeader', value);
        }else{
          this.handleAutoGenerateTitle();
        }
      },
      passTermlyReportHeaderCN: function(value) {
        if (value) {
          this.$set(this, 'termlyReportHeaderCN', value);
        }else{
          this.handleAutoGenerateTitle();
        }
      },
      passTermlyReportContent: function(value) {
        if (value) {
          this.termlyReportContent = value;
        }
      },
      passSingleComment: function(value) {
        if (value) {
          this.singleComment = value;
        }
      },
      passGroupDomain: function(value) {
        if (value) {
          this.groupDomain = value;
        }
      },
      passTermlyReportDomainComment: function(value) {
        if (value) {
          this.termlyReportDomainComment = value;
        }
      },
      passUserFlow: function(value) {
        if (value) {
          this.userFlow = value;
          this.handleUserFlow();
        }
      },
      termlyReportListInt: function(value) {
        if (value) {
          this.getTitleSuggestList();
        }
      },
      studentInfoPart: function(value) {
        if (value) {
          this.handleAutoGenerateTitle();
        }
      },
    },
    data() {
      return {
        inputSearchPendingList: "",
        termlyReportHeader: "",
        termlyReportHeaderCN:"",
        termlyReportContent: "",
        groupDomain: [],
        singleComment: "",
        termlyReportDomainComment: [],
        userFlow: [],
        titleSuggestList: [],
        uiVariable: uiVariable,
        allowEdit: false
      };
    },
    methods: {
      lang,
      resetTitle(){
        this.termlyReportHeader = ""
        this.termlyReportHeaderCN = ""
      },
      handleAutoGenerateTitle() {
          if((!this.passTermlyReportHeader && !this.passTermlyReportHeaderCN)|| this.mode === "New" ){
              let mandarinTeacher = this.teacherAndApproverList?.find(d => d.Role === "Mandarin Teacher");
              let MandarineCreator = mandarinTeacher?.ConID === getUserID();
              if (this.autoGenerateTitle) {
                  let currentFlow = this.userFlow?.find(d => d.ConID === getUserID());
                  let title = this.autoGenerateTitle.split(" ");
                  let currentYear = moment().format("YYYY");
                  if (currentFlow?.Position === "Mandarin Teacher" || MandarineCreator) {
                      switch (title?.[1]) {
                          case "1":
                            this.termlyReportHeader = currentYear + "年上半学年总结报告";
                              break;
                          case "2":
                            this.termlyReportHeader = currentYear + "年下半学年总结报告";
                              break;
                      }
                  }else {
                      if (this.showCNHeader()) {
                        switch (title?.[1]) {
                          case "1":
                            this.termlyReportHeaderCN = currentYear + "年上半学年总结报告";
                            break;
                          case "2":
                            this.termlyReportHeaderCN = currentYear + "年下半学年总结报告";
                            break;
                        }
                      }
                      this.termlyReportHeader = `${this.autoGenerateTitle} ${currentYear} Summative Report`;
                  }
              } else {
                  if (this.studentInfoPart?.SEMD_DetailName) {
                      let semd = this.studentInfoPart?.SEMD_DetailName.replace(/\D/g, "");
                      let semester = semd < 2 ? "1" : "2";
                      let currentYear = moment().format("YYYY");
                      this.termlyReportHeader = `Semester ${semester} ${currentYear} Summative Report`;
                      if(this.showCNHeader()){
                        // this.termlyReportHeader = currentYear +  (semester === 1 ? "年上半学年总结报告":"年下半学年总结报告");
                        this.termlyReportHeaderCN = currentYear +  (semester === "1" ? "年上半学年总结报告":"年下半学年总结报告");
                      }
                  } else {
                      this.termlyReportHeader = "";
                  }
              }


          }else if(this.mode !== "New"){
            this.termlyReportHeader = this.passTermlyReportHeader
            this.termlyReportHeaderCN = this.passTermlyReportHeaderCN
          }

      },
      showCNHeader(){
        let currentUser = this.userFlow?.find(d=>d.ConID === getUserID())
        if(currentUser?.Position.includes("Class Teacher")){
          this.termlyReportHeaderCN = null;
          return false
        }
        const mandarinTeacher = this.userFlow?.find(d=>d.Position === "Mandarin Teacher")
        return !mandarinTeacher
      },
      checkAllowEditStatus() {
        if (this.mode === "View") {
          this.allowEdit = false;
        } else {
          let isApprover = this.allowEditUser.find(d => d.ConID === this.userID);
          this.allowEdit = !!isApprover;
          if (this.nextTurn === true) {
            this.allowEdit = true;
          }
        }

      },
      async handleGeneratePDF(isPreview){
        this.$vs.loading();
        let filepath = await this.downloadTermlyReport();
        let fileName = this.dsKgm_TermlyReport?.[0]?.TeRpStudentID + "_" + this.studentInfoPart.name + ".pdf";
        if (filepath) {
          if(isPreview){
            let newWindow = window.open(filepath, '_blank');
            if (!newWindow) {
              console.error("Unable to open a new window.");
            }
          }else{
            await singleDownload(filepath, fileName);
          }
        }
        this.$vs.loading.close();
      },
      async handleSingleDownload() {
        this.$vs.loading();
        let filepath, fileName;
        // filepath = await this.downloadTermlyReport();
        filepath = `${process.env.VUE_APP_ROOT_API}External/STUDENTS/${this.ddlStudent}/TERMLY_REPORTS/${this.termlyReportPublish?.TeRpPbID}.pdf`
        let student = this.dllStudentList.find(a => a.Student_ID === this.ddlStudent);
        fileName = student.Student_ID + "_" + student.Student_Name + ".pdf";
        await singleDownload(filepath, fileName);

        this.$vs.loading.close();
      },
      async downloadTermlyReport() {
        try {
          const response = await DataSource.shared.generateDownloadTermlyReportPDF(this.currentTermlyReportID);
          if (response) {
            if (response?.code === "2") {
              this.$notify.error({
                title: lang("Error"),
                message: "Academic Year is not available, please check with IT."
              });
              console.log("downloadTermlyReport error", response?.message)
            }else{
              let byteChar = atob(response);
              let byteNo = new Array(byteChar.length);
              for (let i = 0; i < byteChar.length; i++) {
                byteNo[i] = byteChar.charCodeAt(i);
              }

              let byteArray = new Uint8Array(byteNo);
              let file = new Blob([byteArray], { type: "application/pdf;base64" });
              return URL.createObjectURL(file);
            }
          }
        } catch (e) {
          this.$notify.closeAll();
          this.$notify({
            title: lang("Error"),
            dangerouslyUseHTMLString: true,
            message: e
          });
          this.results = e;
        }
      },
      getTitleSuggestList() {
        let titleList = [];
        this.termlyReportListInt.forEach(d => {
          const exist = titleList.find(x => x === d.Title);
          if (!exist) {
            titleList.push(d.Title);
          }
        });
        this.titleSuggestList = titleList;
      },
      checkNew() {
        let currentClassID = this.ddlClass.split(",");
        let currentClassInfo = this.ddlClassList.filter(m => m.PK_Class_ID === currentClassID[2]);

        return currentClassInfo[0].CLS_Class_Incharge_Staff === this.userID;
      },
      handleUserFlow() {
        // this.userFlow.forEach(d => {
        //   d.commentSingle = this.getCommentByDomain("", "single", d.ConID);
        //   d.commentHeader = this.getCommentByDomain("", "header", d.ConID);
        //   d.commentContent = this.getCommentByDomain("", "content", d.ConID);
        // });
        //
        // this.groupDomain.forEach(a => {
        //   this.userFlow.forEach(d => {
        //     d.commentData = this.getCommentByDomain(a.Domain, "data", d.ConID);
        //   });
        // });
      },
      getCommentByDomain(domain, type, userID) {
        if (type === "data") { //domain comment
          if (userID !== this.userID || this.mode === "View" || this.mode === "Pending") {
            let result = [];
            this.termlyReportDomainComment.forEach(m => {
              if (m.TeRpCMDomain === domain && m.TeRpCMConID === userID) {
                result.push(m);
              }
            });

            return result;
          } else {
            return [];
          }
        } else if (type === "header") { //title
          if (userID !== this.userID || this.mode === "View" || this.mode === "Pending") {
            let result = [];

            this.termlyReportDomainComment.forEach(m => {
              if (m.TeRpCMType === "Header" && m.TeRpCMConID === userID) {
                result.push(m);
              }
            });

            return result;
          } else {
            return [];
          }
        } else if (type === "headerCN") { //title
          if (userID !== this.userID || this.mode === "View" || this.mode === "Pending") {
            let result = [];

            this.termlyReportDomainComment.forEach(m => {
              if (m.TeRpCMType === "HeaderCN" && m.TeRpCMConID === userID) {
                result.push(m);
              }
            });

            return result;
          } else {
            return [];
          }
        } else if (type === "content") { //remark
          if (userID !== this.userID || this.mode === "View" || this.mode === "Pending") {
            let result = [];

            this.termlyReportDomainComment.forEach(m => {
              if (m.TeRpCMType === "Content" && m.TeRpCMConID === userID) {
                result.push(m);
              }
            });

            return result;
          } else {
            return [];
          }
        } else if (type === "single") { //single comment
          if (userID !== this.userID || this.mode === "View" || this.mode === "Pending") {
            let result = [];

            this.termlyReportDomainComment.forEach(m => {
              if (m.TeRpCMType === "Single" && m.TeRpCMConID === userID) {
                result.push(m);
              }
            });
            return result;
          } else {
            return [];
          }
        } else if (type === "length") {
          let result = [];

          this.termlyReportDomainComment.forEach(m => {
            if (m.TeRpCMDomain === domain) {
              result.push(m);
            }
          });

          return result.length;
        }

      },
      getCommentHTML(value) {
        if (value === undefined) {
          return "";
        } else {
          return value.replace(/(?:\r\n|\r|\n)/g, "<br>");
        }

      },
      editComment(value) {
        this.termlyReportDomainComment = this.termlyReportDomainComment.map(m => {
          if (m.TeRpCMID === value.TeRpCMID) {
            if (value.editComment === false) {
              m.editComment = true;
              m.editCommentValue = m.TeRpCMComment;
            } else {
              m.editComment = false;
              m.editCommentValue = "";
            }
          }
          return m;
        });
        this.$forceUpdate();

      },
      async saveTermlyReportComments(isSubmit) {
        try {
          this.$vs.loading();
          let currentClassID = this.ddlClass.split(",");
          let domainComments = [];
          let mandarinTeacher = this.userFlow?.find(d=>d.Position?.includes("Mandarin Teacher"))
          if (this.userMain) {
            //header
            if(!this.currentEditor?.Position?.includes("Class Teacher")){
              let tempCommentHeader = {
                Domain: "Header",
                Comment: this.termlyReportHeader,
                Type: "Header"
              };

              domainComments.push(tempCommentHeader);

              if(this.termlyReportHeaderCN && !mandarinTeacher){
                let tempCommentHeaderCN = {
                  Domain: "HeaderCN",
                  Comment: this.termlyReportHeaderCN,
                  Type: "HeaderCN"
                };

                domainComments.push(tempCommentHeaderCN);
              }
            }
            //content
            let tempCommentContent = {
              Domain: "Content",
              Comment: this.termlyReportContent,
              Type: "Content"
            };

            domainComments.push(tempCommentContent);

            //domain
            this.groupDomain.forEach(m => {
              let tempCommentDomain = {
                Domain: m.Domain,
                Comment: m.Comment,
                Type: "Domain"
              };

              domainComments.push(tempCommentDomain);
            });
          } else {
            let tempCommentDomain = {
              Domain: "Single",
              Comment: this.singleComment,
              Type: "Single"
            };

            domainComments.push(tempCommentDomain);
          }

          const response = await DataSource.shared.saveTermlyReportComments(this.currentTermlyReportID, JSON.stringify(domainComments), currentClassID[2]);
          // const response = await DataSource.shared.saveTermlyReportComments(this.currentTermlyReportID, JSON.stringify(domainComments), this.ddlClass);
          if (response) {
            if (response.code === "99") {
              console.log("Save Summative Report: Error");
            } else if (response.code === "88") {
              window.location.replace("/");
            } else if (response.code === "2") {
              this.$notify.error({
                title: "Invalid",
                message: "Invalid Action..."
              });
            } else {
              if (!isSubmit) {
                this.$notify({
                  title: "Saved",
                  message: "Summative Report Saved..."
                });
              }

            }
          }

        } catch (e) {
          this.results = e;
        }
        this.$vs.loading.close();

      },
      async handleSave(status) {
        switch (status) {
          case "save":
            await this.saveTermlyReportComments();
            this.$emit("clear", "All");
            break;
          case "submit":
            await this.saveTermlyReportComments(true);
            this.$emit("submitTermlyReport");
            break;
        }
      },
      async SaveTermlyReport() {
        try {
          // let missDomainComment = false;
          // this.groupDomain.forEach(m => {
          //     if(!missDomainComment) {
          //         if(m.Comment === '' || m.Comment === undefined || m.Comment === null){
          //             missDomainComment = true;
          //         }
          //     }
          // });

          // if (this.termlyReportHeader === '' || this.termlyReportContent === ''){
          //     this.$notify.error({
          //         title: 'Required',
          //         message: 'Required Header and Content...'
          //     });
          // } else if (missDomainComment) {
          //     this.$notify.error({
          //         title: 'Required',
          //         message: 'Required all Domain comment...'
          //     });

          this.$vs.loading();

          let currentClassID = this.ddlClass.split(",");

          let domainComments = [];
          this.groupDomain.forEach(m => {
            let tempCommentDs = {
              Domain: m.Domain,
              Comment: m.Comment
            };

            domainComments.push(tempCommentDs);
          });

          if(this.termlyReportHeaderCN){
            let tempCommentHeaderCN = {
              Domain: "HeaderCN",
              Comment: this.termlyReportHeaderCN,
              Type: "HeaderCN"
            };

            domainComments.push(tempCommentHeaderCN);
          }

          let teacherApproverList = this.teacherAndApproverList;
          const response = await DataSource.shared.saveTermlyReport(this.ddlStudent, currentClassID[2], this.termlyReportHeader, this.termlyReportContent, JSON.stringify(domainComments), JSON.stringify(this.selectedTeacherList), JSON.stringify(teacherApproverList));
          if (response) {
            if (response.code === "99") {
              console.log("Save Summative Report: Error");
            } else if (response.code === "88") {
              window.location.replace("/");
            } else if (response.code === "2") {
              this.$notify.error({
                title: "Required",
                message: "Required Teacher/Coordinator/Principle..."
              });
            } else {
              this.$notify({
                title: "Saved",
                message: "Summative Report Saved..."
              });

              this.$emit("clear", "All");
            }
          }

          this.$vs.loading.close();
        } catch (e) {
          this.results = e;
        }
      },
      updateTermlyReportHeader(value) {
        this.termlyReportHeader = value;
      },
      async removeTeacher(flowInfo) {
        try {
          const response = await DataSource.shared.removeTeacherTermlyReport(this.currentTermlyReportID, flowInfo.ConID);
          if (response) {
            let newDomain = cloneObject(this.groupDomain);
            this.$emit("getTermlyReport", this.currentTermlyReportID);
            this.$notify({
              title: "Removed",
              message: "Teacher had been removed from report..."
            });
            this.groupDomain = newDomain;
          }
        } catch (e) {
          console.log(e);
        }
      },
      checkIsOptionalDomain(domain, type) {
        let optionalDomain = ["The Child as Communicator (English)", "The Child as Communicator (Mandarin)",
          'Translation of "The Child as Communicator" (online translator)'];
        let isOptional = optionalDomain.find(d => d === domain);
        let isCommented = false;
        if (this.mode === "Draft") {
          return true;
        }
        if (isOptional) {
          this.userFlow.forEach(d => {
            if (d.Type === "Creator" || d.Type === "Main") {
              let comment = this.getCommentByDomain(type === "single" ? "" : domain, type, d.ConID);
              if (comment?.[0]?.TeRpCMComment) {
                isCommented = true;
              }
            }
          });
        } else if (type === "single") {
          let singleList = [];
          this.userFlow.forEach(d => {
            let comment = this.getCommentByDomain("", type, d.ConID);
            if (comment?.[0]?.TeRpCMComment) {
              singleList.push(comment?.[0]?.TeRpCMComment);
            }
          });
          isCommented = !!singleList.length;
        } else {
          isCommented = true;
        }
        return isCommented;
      },
      getReportPeriod(semdFrom, semdTo) {
        let from = getFormatDate(semdFrom, "Do MMMM", "DD/MM/YYYY hh:mm:ss");
        let to = getFormatDate(semdTo, "Do MMMM YYYY", "DD/MM/YYYY hh:mm:ss");

        if (!semdFrom || !semdTo) {
          return "-";
        }
        return from + " to " + to;
      }
    }
  };

</script>
<style lang="scss" scoped>
    @import "../termly";
</style>
<style>
    .termly_remove_icon button {
        padding: 0 !important;
        background: none !important;
        border: 0px;
    }

    .termly_remove_icon button span {
        font-size: 1rem !important;
    }

</style>